/* eslint-disable no-unused-vars */
import { h, render } from 'preact';
import clsx from 'clsx';
import { useEffect } from 'preact/hooks';
import ProductCard from '../product-card/product-card';
import { getProductByHandle } from '../utils/storefront/get-products';
import { waitForElm, hasRichTextContent } from '../utils/helpers';
import AddToCartButton from '../product/product-add-to-cart';
import { useWindowSize } from '../utils/window-size';

export default (element, data) => {
  const init = async () => {
    const collectedProducts = await collectProducts();
    render(<ShopCollection collectedProducts={collectedProducts} />, element);
  };

  const collectProducts = async () => {
    const promises = data.products.map(async (p, index) => {
      const product = await getProductByHandle(p).then(
        (response) => response.data.productByHandle,
      );
      return product;
    });
    return Promise.all(promises);
  };

  const ShopCollection = ({ collectedProducts }) => {
    const { isMobile } = useWindowSize();

    const image = isMobile ? data.image_mobile : data.image_desktop;

    const buttonStyle =
      data.buttonStyle === 'border' ? 'btn-primary-stroke' : 'btn-primary';

    useEffect(() => {
      waitForElm('.shop-collection-section .yotpo.bottomLine').then(() => {
        if (window.yotpo?.initWidgets) {
          window.yotpo.initWidgets();
          let attempts = 0;
          const interval = setInterval(() => {
            if (
              document.querySelectorAll(
                '.shop-collection-section .yotpo-bottomline a',
              ).length > 0 ||
              attempts > 1000
            ) {
              clearInterval(interval);
              document
                .querySelectorAll(
                  '.shop-collection-section .yotpo-bottomline a',
                )
                .forEach((widget) => {
                  widget.remove();
                });
            }
            attempts += 1;
          }, 100);
        }
      });
    }, []);

    if(collectedProducts.length < 1) return null;

    return (
      <div
        // eslint-disable-next-line max-len
        className={`bg-neutral pt-5 pb-5 laptop:p-10 flex gap-[13px] laptop:gap-5 flex-col laptop:${data.textAlignment}`}
      >
        <div
          className="bg-cover px-[15px] pt-5 pb-[300px] bg-center laptop:pb-0 laptop:pt-[50px] laptop:pl-10 laptop:pr-[50px] flex flex-col justify-start w-full laptop:max-w-[50%]"
          style={{ backgroundImage: `url(${image})` }}
        >
          {data.eyebrow && (
            <p className="eyebrow mb-2.5" style={{ color: data.textColor }}>
              {data.eyebrow}
            </p>
          )}
          {hasRichTextContent(data.headerRte) ? (
            <div
              className="rte mb-1 shop-collection-section-header"
              style={{ color: data.textColor }}
              dangerouslySetInnerHTML={{
                __html: data.headerRte,
              }}
            ></div>
          ) : (
            <p className="h4 mb-1" style={{ color: data.textColor }}>
              {data.header}
            </p>
          )}
          <p
            className="font-16 mb-4 max-w-[440px]"
            style={{ color: data.textColor }}
          >
            {data.description}
          </p>
          {!isMobile && data.enableAddallButton && (
            <AddToCartButton
              showQty={false}
              showPrice={true}
              isMargin={false}
              showMessage={false}
              customClass={'max-w-[333px]'}
              btnFont="cta-small"
              btnStyle={
                data.imageContrast === 'dark'
                  ? `${buttonStyle}-inverse`
                  : buttonStyle
              }
              multipleAdd={collectedProducts}
            />
          )}
        </div>
        <div className="flex mb-3 laptop:mb-0 gap-2 laptop:gap-5 flex-wrap px-5 laptop:px-0">
          {collectedProducts.map((p, index) => (
            <ProductCard
              currentProduct={p}
              key={`shop-collection-${index}`}
              customClass="w-[calc(50%-4px)] laptop:w-[calc(50%-10px)]"
              hideATC={!p.availableForSale}
              disableScentColor={true}
            />
          ))}
        </div>
        {isMobile && data.enableAddallButton && (
          <div className="px-5">
            <AddToCartButton
              showQty={false}
              showPrice={true}
              isMargin={false}
              showMessage={false}
              btnFont="cta-small"
              btnStyle={buttonStyle}
              multipleAdd={collectedProducts}
            />
          </div>
        )}
      </div>
    );
  };

  init();
};
